var FilterBarLayout          = require("./FilterBarLayout"),
    RepeaterArrayDataAdapter = require("enyo-ui/RepeaterArrayDataAdapter"),
    SimpleRepeater           = require("enyo-ui/SimpleRepeater"),
    TypeFilterDropdown       = require("./TypeFilterDropdown.js"),
    TypeFilterButton         = require("./TypeFilterButton.js"),
    config                   = require("app/config"),
    deepEqual                = require("fast-deep-equal"),
    frameThrottle            = require("enyo-perf/utils").frameThrottle,
    get                      = require("object-path").get,
    kind                     = require("enyo/kind"),
    util                     = require("enyo/utils");

require("./FilterBar.less");
require("app/theme/IconButton--filter-bar.less");

module.exports = kind(/** @lends  app.SearchPage.FilterBar.prototype */ {

    /**
     * @private
     */
    name: "app.SearchPage.FilterBar",

    /**
     * @private
     */
    layoutKind: FilterBarLayout,

    /**
     * @private
     */
    classes: "app-search-page-filter-bar",

    /**
     * The state of this menu.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:       "wrapper",
        classes:    "app-search-page-filter-bar__wrapper",
        components: [{
            name:            "inlineMenu",
            kind:            SimpleRepeater,
            classes:         "app-search-page-filter-bar__inline-menu",
            dataAdapterKind: RepeaterArrayDataAdapter,

            /**
             * The kind that will be rendered for each item in the dataset.
             *
             * @type  {enyo.Control}
             * @public
             */
            childKind:    TypeFilterButton,
            childOptions: {
                theme: "filter-bar"
            }
        }, {
            name:    "dropdownMenu",
            kind:    TypeFilterDropdown,
            classes: "app-search-page-filter-bar__dropdown-menu"
        }]
    }],

    /**
     * @private
     */
    handlers: {
        requestTypeFilter: "requestTypeFilter"
    },

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var state       = this.state || {},
            typeParam   = get(state, "params.type", null),
            types       = get(config, "search.sortedContentTypes", []),
            filterData  = [],
            $inlineMenu = this.$.inlineMenu;

        this.$.dropdownMenu.set("state", state);

        // Empty filter, aka just show everything
        filterData.push({
            id:     util.uid(),
            type:   null,
            active: typeParam === null
        });

        types.forEach(function(type) {
            filterData.push({
                id:     util.uid(),
                type:   type,
                active: typeParam === type
            });
        });

        // Update repeater only if data changed
        if (!deepEqual(filterData, $inlineMenu.get("data"))) {
            $inlineMenu.set("data", filterData);
        }

        this.resize();
    },

    /**
     * @param   {enyo.Control}  sender  The sender
     * @param   {Object}        event   The event
     * @return  {boolean}       Stop propagation
     * @private
     */
    requestTypeFilter: function(sender, event) {
        this.set("type", event.type);

        this.bubbleUp("requestSearch");

        return true;
    }

});
